import axios from "axios";

const domainURL = "https://ly-iphone-store-backend.onrender.com/api";
// const domainURL = "http://localhost:5002/api";

export const ContactService = {
  sendMail: async (data) => {
    try {
      const response = await axios.post(`${domainURL}/contact/send`, data, {
        headers: { "Content-Type": "application/json" },
      });
      if (response) return { Data: response.data, Status: response.status };
    } catch (error) {
      console.error("Error sending mail:", error);
      return { Data: null, Error: error };
    }
  },
};
